
import {Component, Vue} from "vue-property-decorator";
import DashboardItem from "./DashboardItem.vue";
import {
  currentUserModule, documentModule,
  studyInstitutesModule,
  studyPatientsModule
} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;
import IQueryListResponse = MdbsCore.IQueryListResponse;

@Component({
  components: {DashboardItem}
})
export default class Dashboard extends Vue {
  private queryMyResponse: IQueryListResponse | null = null;

  get canSeePatients() {
    return currentUserModule.hasRight(Rights.StudyPatientGetMyCmd) || currentUserModule.hasRight(Rights.StudyPatientGetAllCmd);
  }

  get canSeeInstituteOverview() {
    return (currentUserModule.hasRight(Rights.StudyInstituteOverviewGetAllCmd) || currentUserModule.hasRight(Rights.StudyInstituteOverviewGetMyCmd));
  }

  get canSeeVisualization(){
    return currentUserModule.hasRight(Rights.AkromegalieGetVisualizationDataCmd) || currentUserModule.hasRight(Rights.AkromegalieGetMyVisualizationDataCmd);
  }

  get canSeeDocuments() {
    return currentUserModule.hasRight(Rights.DocumentGetAllCmd);
  }

  get canSeeCalendar() {
    return false;
  }

  get canSeeQueries() {
    return currentUserModule.hasRight(Rights.QueryGetAllCmd) || currentUserModule.hasRight(Rights.QueryGetMyCmd);
  }

  get canSignVisits() {
    return currentUserModule.hasRight(Rights.VisitSignatureCmd);
  }

  get calendarText() {
    return "0 Kalender-Einträge";
  }

  get patientText() {
    if (!studyPatientsModule.isLoaded) {
      return "...";
    }
    const count = studyPatientsModule.studyPatients.length;
    return count + " Patient" + (count !== 1 ? "en" : "") + " registriert";
  }

  get queriesText() {
    if (!this.queryMyResponse || (
        this.queryMyResponse.itemsNew == 0 &&
        this.queryMyResponse.itemsAnswered == 0 &&
        this.queryMyResponse.itemsRenewed == 0 &&
        this.queryMyResponse.itemsPending == 0 &&
        this.queryMyResponse.itemsClosed == 0
    ))
      return "Es liegen keine Queries vor."

    const queryText = "<ul><li>" + (this.queryMyResponse.itemsNew ?? 0) + " neue Queries</li>" +
        "<li>" + (this.queryMyResponse.itemsAnswered ?? 0) + " beantwortete Queries</li>" +
        "<li>" + (this.queryMyResponse.itemsRenewed ?? 0) + " erneuerte Queries</li>" +
        "<li>" + (this.queryMyResponse.itemsPending ?? 0) + " ausstehende Queries</li>" +
        "<li>" + (this.queryMyResponse.itemsInvisible ?? 0) + " unsichtbare Queries</li>" +
        "<li>" + (this.queryMyResponse.itemsNoLongerRelevant ?? 0) + " nicht mehr relevante Queries</li>" +
        "<li>" + (this.queryMyResponse.itemsClosed ?? 0) + " geschlossene Queries</li></ul>";

    return queryText;
  }

  get documentsText() {
    return this.documents.length + (this.documents.length == 1? " Dokument" :  " Dokumente");
  }

  get documents() {
    return documentModule.documents;
  }

  get centerText() {
    const count = studyInstitutesModule.studyInstitutesOverview.length;
    return `${count} Zentren`;
  }

  get userStudyInstitutes() {
    return studyInstitutesModule.studyInstitutes.length;
  }

  show(view: string) {
    this.$router.push(view);
  }

}
